import React from "react";
import { Box, Typography } from "@mui/material";

export const TEMPLATE_WIDTH = 3508;
export const TEMPLATE_HEIGHT = 2480;

export const config = {
  width: TEMPLATE_WIDTH,
  height: TEMPLATE_HEIGHT,
  regions: [
    {
      id: "front",
      x: 0.05,
      y: 0.18,
      width: 0.27,
      height: 0.62,
    },
    {
      id: "back",
      x: 0.35,
      y: 0.18,
      width: 0.27,
      height: 0.62,
    },
    {
      id: "detail_1",
      x: 0.66,
      y: 0.18,
      width: 0.29,
      height: 0.19,
    },
    {
      id: "detail_2",
      x: 0.66,
      y: 0.4,
      width: 0.29,
      height: 0.19,
    },
    {
      id: "detail_3",
      x: 0.66,
      y: 0.62,
      width: 0.29,
      height: 0.18,
    },
  ],
  textFields: [
    {
      id: "marca",
      x: 0.05,
      y: 0.04,
      width: 0.28,
      height: 0.05,
      fontSize: 52,
      fontWeight: "bold",
      color: "#ffffff",
      backgroundColor: "#111111",
    },
    {
      id: "info",
      x: 0.66,
      y: 0.84,
      width: 0.29,
      height: 0.08,
      fontSize: 38,
      fontWeight: "normal",
      color: "#1a1a1a",
    },
  ],
};

const regionCard = {
  border: "1px solid #d7d7d7",
  borderRadius: "8px",
  backgroundColor: "#fcfcfc",
  overflow: "hidden",
  position: "relative",
};

const dashedOverlay = {
  position: "absolute",
  inset: "6%",
  border: "1px dashed #9f9f9f",
  borderRadius: "6px",
};

function PlantillaPremiumTechpack({ marca = "MARCA", className }) {
  return (
    <Box
      className={className}
      sx={{
        width: "100%",
        height: "100%",
        aspectRatio: `${TEMPLATE_WIDTH}/${TEMPLATE_HEIGHT}`,
        bgcolor: "#ffffff",
        border: "1px solid #d0d0d0",
        borderRadius: "10px",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "4%",
          width: "28%",
          height: "5%",
          bgcolor: "#111",
          borderRadius: "4px",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          px: 1.1,
        }}
      >
        <Typography sx={{ fontSize: ".28rem", fontWeight: 700 }}>
          {marca}
        </Typography>
      </Box>

      <Box sx={{ position: "absolute", left: "5%", top: "18%", width: "27%", height: "62%", ...regionCard }}>
        <Box sx={dashedOverlay} />
      </Box>
      <Box sx={{ position: "absolute", left: "35%", top: "18%", width: "27%", height: "62%", ...regionCard }}>
        <Box sx={dashedOverlay} />
      </Box>

      {[
        { top: "18%", h: "19%" },
        { top: "40%", h: "19%" },
        { top: "62%", h: "18%" },
      ].map((s, idx) => (
        <Box
          key={idx}
          sx={{
            position: "absolute",
            left: "66%",
            top: s.top,
            width: "29%",
            height: s.h,
            ...regionCard,
          }}
        >
          <Box sx={dashedOverlay} />
        </Box>
      ))}

      <Box
        sx={{
          position: "absolute",
          left: "66%",
          top: "84%",
          width: "29%",
          height: "8%",
          borderRadius: "8px",
          border: "1px solid #d7d7d7",
          backgroundColor: "#f7f7f7",
        }}
      />
    </Box>
  );
}

export default PlantillaPremiumTechpack;
